import { render, staticRenderFns } from "./DeviceStatusMarker.vue?vue&type=template&id=40408dab"
import script from "./DeviceStatusMarker.vue?vue&type=script&lang=js"
export * from "./DeviceStatusMarker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports